import { type IErrorData, type IMeta } from './getErrorData';

/**
 * Разбирает `meta.error` конверта ответа: бэкенд отдаёт 200 OK с непустым
 * `meta.error` так же часто, как настоящие HTTP-коды, поэтому проверять надо оба
 * канала. Ошибка приходит либо объектом `{ message, code }`, либо строкой (legacy).
 *
 * @param meta - объект meta из конверта ответа
 * @returns данные ошибки либо null, если ответ успешный
 */
export const getApiEnvelopeError = (meta: IMeta): IErrorData | null => {
  const { error } = meta;

  if (error === null) {
    return null;
  }

  if (typeof error === 'string') {
    return error.trim() === '' ? null : { message: error };
  }

  return { message: error.message, code: error.code };
};
